// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ca39140","455":"50a6bdb3","977":"d18f079a"}[chunkId] + ".chunk.js";
};